import { Fragment } from "react";
import { Col, Container, Row } from "reactstrap";
import BasicInformation from "./BasicInformation";
import AdditionalInformation from "./AdditionalInformation";
import { useWizardContext } from "Pages/Melder/Indienen/WizardContext";
import { useOrganizationCodesLink } from "Api/Melder/Indinen";


const GeneralInformation = ({
  formikProps,
  formDataState,
  setFormDataState,
  isDisabled,
  setIsDisabled,
  getAbsenceCodeByCommunityId,
}) => {
  const { values } = formikProps;
  const { organizationsList } = useWizardContext();

  const filteredOrganisation = organizationsList.find(
    (organization) =>
      String(organization.iCommunityId) === String(values.organisationId)
  );

  const shouldFetchLink =
    !!filteredOrganisation &&
    !!values.codeId &&
    !!(
      filteredOrganisation.vVerzuimmeldingLink ||
      filteredOrganisation.vVerlofmeldingLink
    );

  const { data: linkResponse } = useOrganizationCodesLink(
    filteredOrganisation?.iCommunityId,
    values.schoolId,
    values.absentId,
    shouldFetchLink
  );

  const verlofLink = linkResponse?.data || "";

  return (
    <Fragment>
      <Container>
        <Row>
          <Col>
            <BasicInformation
              formikProps={formikProps}
              formDataState={formDataState}
              setFormDataState={setFormDataState}
              isDisabled={isDisabled}
              setIsDisabled={setIsDisabled}
              getAbsenceCodeByCommunityId={getAbsenceCodeByCommunityId}
            />
          </Col>

          <Col>
            <AdditionalInformation
              formikProps={formikProps}
              formDataState={formDataState}
              setFormDataState={setFormDataState}
              isDisabled={isDisabled}
              setIsDisabled={setIsDisabled}
              verlofLink={verlofLink}
              planningId={filteredOrganisation?.planningId ?? 3}
            />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default GeneralInformation;
